export default __webpack_public_path__ + "static/media/IF_MyStrengths_Big.a2fea649.jpg";